export default __webpack_public_path__ + "static/media/maithri_goonetilleke.e31bfd9a.jpg";